module.exports = __webpack_public_path__ + "img/452-dcb6ab.png";